import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { configs } from '@hero/configs';
import { useRecognitionCreateModal } from '@hero/hooks';
import { PageLayout } from '@hero/layouts';
import { RecognitionTable } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetUser } from '@hero/services/organization-service/hooks';

function MyRecognitions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { data: userData } = useGetUser();

  const { showRecognitionCreateModal } = useRecognitionCreateModal();

  useEffect(() => {
    if (state?.isNewRecognition) {
      showRecognitionCreateModal();
    }
  }, [state]);

  function handleCreate() {
    if (configs?.general?.simplifyFlow && !userData?.meta?.isPunchoutUser) {
      navigate(ROUTE_PATHS.SEND_GIFT_OCCASIONS);
    } else {
      showRecognitionCreateModal();
    }
  }

  return (
    <PageLayout
      header={{
        title: t('oneTimeGifts'),
        createButton: {
          children: t('createNew'),
          onClick: handleCreate
        }
      }}
    >
      <RecognitionTable
        emptyTableContent={{
          feature: 'recognition',
          hasDescription: true,
          description: t('pleaseTryDifferentFilter')
        }}
      />
    </PageLayout>
  );
}

export { MyRecognitions };
